// extracted by mini-css-extract-plugin
export default {"map":"Map_map__2kJxT","region":"Map_region__m-Wen","regionDisabled":"Map_regionDisabled__TGL-2"};